/**
 * Jedna se u eventu o klik - leve tlacitko mysi
 */
export function isMouseLeftOrTouch(event) {
	return event.pointerType !== "mouse" || (event.pointerType === "mouse" && (event.which === 1 || event.button === 0));
}

/**
 * Jedna se u eventu o klik pravym tlacitkem mysi?
 */
export function isMouseRight(event) {
	return event.pointerType === "mouse" && (event.which === 3 || event.button === 2);
}
